/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCButton from "components/buttons";
import { ReactComponent as CloudOffSvg } from "../../resources/images/cloud-off-icon.svg";

/* Styles */
import styles from "./styles.js"

const FailedEndpointView = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.wrapper}>
      <div>
        <CloudOffSvg />
      </div>
      <h1><FormattedMessage id="failedEndpointView.title"/></h1>
      <p><FormattedMessage id="failedEndpointView.description"/></p>
      <UCButton
        className={classes.retryBtn}
        type="default"
        onClick={() => window.location.reload()}
        text={<FormattedMessage id="failedEndpointView.retry" />}
      />
    </div>
  )
}

export default FailedEndpointView;
